var sidebarSearchForm = vueIfExists({
    mixins: [win.buttonSpinner, win.availCheckMixin],
	el: '#sidebar-search-form',
	data: {
		sharedState: store.state,
        hotels: [],
        handle: null,
        panelCollapsed: {
            'search-filter': true,
            'search-sort': true
        },
        loading: false,
        noResults: false,
        cache: {
            handle: null,
            query: {},
            expiresSec: 5 * 60,
            time: 0,
            offset: 0
        },
        handlePolling: null,
        sortOrder: {5: 'desc'},
        sortBy: 0,
        offset: 0,
        limit: 15,
        availableHotels: 0,
        totalHotels: 0,
        listTotal: 0,
        withoutAvailability: true
	},
    computed: {
        isFormInputError: function() {
            return this.sharedState.errorType && ['noSearch', 'noDates', 'datesPast', 'datesApart', 'datesMismatch']
                .indexOf(this.sharedState.errorType) != -1;
        }
    }
});